import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const ListItemService = {
    getAllListItem,
    getListItemById
};

async function getAllListItem() {
    const configOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/crm/list-item/getAll/ListItems`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getListItemById(list_id) {
    const configOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/crm/list-item/getLists/${list_id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}